import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { useIntl } from "react-intl";
import { useAlert } from "../../Alert";
import { useCallback } from "react";

export function useDeleteAlert(onDelete: () => void) {
  const Alert = useAlert();
  const intl = useIntl();
  const intl_tokens = useIntlTokens();
  const onDeleteAlert = useCallback(
    () =>
      Alert.alert(
        intl.formatMessage({
          defaultMessage: "Delete image",
          description: "ImageViewer delete image alert title",
        }),
        intl.formatMessage({
          defaultMessage: "Are you sure you want to delete this image?",
          description: "ImageViewer delete image alert description",
        }),
        [
          {
            text: intl_tokens.Cancel,
            style: "cancel",
          },
          {
            text: intl_tokens.Delete,
            style: "destructive",
            onPress: () => {
              onDelete();
            },
          },
        ]
      ),
    [Alert, intl, intl_tokens.Cancel, intl_tokens.Delete, onDelete]
  );
  return onDeleteAlert;
}
